import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateEmployeeCommissionInputSchema, UpdateEmployeeCommissionInputSchema, EmployeeCommissionResponseSchema, CreateEmployeeBonusInputSchema, UpdateEmployeeBonusInputSchema, EmployeeBonusResponseSchema, } from "@hourly/api/incentive";
// ===== COMMISSION CONTRACTS =====
const createCommissionContract = oc
    .route({ method: "POST", path: "/incentives/commissions", successStatus: 201 })
    .input(CreateEmployeeCommissionInputSchema)
    .output(EmployeeCommissionResponseSchema);
const updateCommissionContract = oc
    .route({ method: "PUT", path: "/incentives/commissions/{id}" })
    .input(UpdateEmployeeCommissionInputSchema.extend({
    id: z.uuid(),
    employmentId: z.uuid(),
}))
    .output(EmployeeCommissionResponseSchema);
const deleteCommissionContract = oc
    .route({ method: "DELETE", path: "/incentives/commissions/{id}", successStatus: 204 })
    .input(z.object({ id: z.uuid(), employmentId: z.uuid() }))
    .output(z.void());
// ===== BONUS CONTRACTS =====
const createBonusContract = oc
    .route({ method: "POST", path: "/incentives/bonuses", successStatus: 201 })
    .input(CreateEmployeeBonusInputSchema)
    .output(EmployeeBonusResponseSchema);
const updateBonusContract = oc
    .route({ method: "PUT", path: "/incentives/bonuses/{id}" })
    .input(UpdateEmployeeBonusInputSchema.extend({
    id: z.uuid(),
    employmentId: z.uuid(),
}))
    .output(EmployeeBonusResponseSchema);
const deleteBonusContract = oc
    .route({ method: "DELETE", path: "/incentives/bonuses/{id}", successStatus: 204 })
    .input(z.object({ id: z.uuid(), employmentId: z.uuid() }))
    .output(z.void());
// ===== CONTRACT ROUTER =====
export const incentiveContract = {
    createCommission: createCommissionContract,
    updateCommission: updateCommissionContract,
    deleteCommission: deleteCommissionContract,
    createBonus: createBonusContract,
    updateBonus: updateBonusContract,
    deleteBonus: deleteBonusContract,
};
//# sourceMappingURL=incentive.js.map